import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import { TaskDescriptionTip } from '../components/TaskDescriptionTip.tsx';
import { messages } from './linkWorkItems.messages.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	return (
		<TaskDescription>
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<TaskDescriptionTip>{formatMessage(messages.tip)}</TaskDescriptionTip>
		</TaskDescription>
	);
};

export const linkWorkItems = {
	id: 'link-work-items',
	title: messages.title,
	description: <Description />,
};
